<span class="gutachten-ergebnis-line-element" :class="classLocal" aria-hidden="true" :style="styleLocal">&nbsp;</span>